<template>
    <div class="order-general">
        <QrCodeModalScan
            :is-active="qrCodeIsActive"
            @on-detect="detectHandle"
            @on-close="closeBarcode"
        />
        <div class="order-general__input-wrapper">
            <div class="order-general__price-wrapper">
                <v-text-field
                    v-model="fields.totalPrice"
                    dense
                    outlined
                    type="number"
                    name="price-for-new"
                    data-test-id="wigs--add-new-wig-form--price-input"
                    :label="textContent['price']"
                    :error-messages="errors['totalPrice']"
                    class="order-general__price-input"
                    @input="errors['totalPrice'] = ''"
                >
                </v-text-field>
                <v-select
                    v-model="fields.price_currency"
                    :items="currencyOptions"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    class="order-general__currency-select"
                    data-test-id="wigs--add-new-wig-form--currency-select"
                    @change="errors['price_currency'] = ''"
                >
                    <template #item="{ item }">
                        <span>{{ item.symbol }}</span>
                    </template>
                    <template #selection="{ item }">
                        <span>{{ item.symbol }}</span>
                    </template>
                </v-select>
            </div>
            <div
                v-if="errors['price_currency']"
                class="order-general__currency-error"
            >
                {{ errors['price_currency'] }}
            </div>
        </div>

        <div class="order-general__input-wrapper">
            <v-text-field
                v-model="fields.barcode"
                dense
                outlined
                type="text"
                name="barcode-for-new"
                data-test-id="wigs--add-new-wig-form--barcode-input"
                :label="textContent['barcode']"
                :error-messages="errors['barcode']"
                @input="errors['barcode'] = ''"
            >
                <template #append>
                    <button class="icon-container" @click="scanBarcode">
                        <v-icon>fas fa-barcode</v-icon>
                    </button>
                </template>
            </v-text-field>
        </div>
        <div class="order-general__input-wrapper">
            <v-text-field
                v-model="fields.user_generated_id"
                dense
                outlined
                type="text"
                name="uniqID-for-new"
                :label="textContent['uniq-id']"
                :error-messages="errors['user_generated_id']"
                @input="errors['user_generated_id'] = ''"
            >
            </v-text-field>
        </div>

        <div class="order-general__input-wrapper">
            <v-text-field
                v-model="fields.order_number"
                dense
                outlined
                type="number"
                name="order_number"
                :label="$t('pages.wigPage.generalList.items.orderNumber')"
                :error-messages="errors['order_number']"
                @input="errors['order_number'] = ''"
            >
            </v-text-field>
        </div>

        <div class="order-general__input-wrapper">
            <v-textarea
                v-model="fields.info"
                outlined
                name="info"
                :label="textContent['info']"
                rows="2"
            >
            </v-textarea>
        </div>
        <div class="order-general__input-wrapper">
            <v-textarea
                v-model="fields['details']"
                outlined
                name="details"
                data-test-id="wigs--add-new-wig-form--details-input"
                :label="textContent['details']"
                rows="2"
                :error-messages="errors['shippingInfo']"
                @input="errors['shippingInfo'] = ''"
            >
            </v-textarea>
        </div>
        <div class="order-general__input-wrapper">
            <v-textarea
                v-model="fields['shippingInfo']"
                outlined
                name="details"
                :label="textContent['storage-info']"
                rows="2"
                :error-messages="errors['shippingInfo']"
                @input="errors['shippingInfo'] = ''"
            >
            </v-textarea>
        </div>
        <div
            class="order-general__input-wrapper order-general__input-wrapper--half"
        ></div>
    </div>
</template>

<script>
import QrCodeModalScan from '@/components/modals/qr-code-modal-scan'
import languageMixin from '@/mixins/language.mixin'
import { mapActions } from 'vuex'
import { actionTypes } from '@/store/modules/modals'

export default {
    name: 'OrderFormGeneral',
    components: {
        QrCodeModalScan,
    },
    mixins: [languageMixin],
    props: {
        data: {
            type: Object,
            default: () => ({
                fields: {
                    totalPrice: '',
                    barcode: '',
                    state: '',
                    info: false,
                    shippingInfo: '',
                    is_repair: false,
                    is_reword: false,
                    order_number: '',
                },
                errors: {
                    totalPrice: '',
                    barcode: '',
                    state: '',
                    info: false,
                    shippingInfo: '',
                    is_repair: false,
                    is_reword: false,
                    order_number: '',
                },
            }),
        },
    },
    data() {
        return {
            modals: {
                barcode: {
                    isActive: false,
                },
            },
            details: '',
            qrCodeIsActive: false,
        }
    },
    computed: {
        fields: function () {
            return this.data.fields
        },
        errors: function () {
            return this.data.errors
        },
        currencyOptions: function () {
            return [
                { text: 'ILS', value: 'ILS', symbol: '₪' },
                { text: 'USD', value: 'USD', symbol: '$' },
            ]
        },
    },
    watch: {
        data: function () {
            return (this.fields.info = this.fields.shippingInfo.length !== 0)
        },
    },
    methods: {
        ...mapActions('modals', { onOpen: actionTypes.openPopUp }),
        scanBarcode: function () {
            this.qrCodeIsActive = true
        },
        detectHandle: function (con) {
            this.fields.barcode = con
        },
        closeBarcode: function () {
            this.qrCodeIsActive = false
        },
    },
}
</script>

<style scoped lang="scss">
.order-general {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 15px 0;

    &__input-wrapper {
        width: 100%;

        &--half {
            width: 48%;
        }

        .icon-container {
            height: 24px;
            display: flex;
            align-items: center;

            i {
                font-size: 18px;
            }
        }
    }

    &__price-wrapper {
        display: flex;
        gap: 8px;
        align-items: flex-start;
    }

    &__price-input {
        flex: 1;
    }

    &__currency-select {
        width: 80px;
        max-width: 80px;
        flex-shrink: 0;
        min-width: 60px;

        :deep(.v-input__control) {
            min-height: 40px;
        }

        :deep(.v-select__selection) {
            font-size: 18px;
            font-weight: 500;
        }
    }

    &__currency-error {
        color: #ff5252;
        font-size: 12px;
        margin-top: 4px;
        padding-left: 12px;
    }
}
</style>
